<template>
  <div class="container pr">
    <Header @input="input"></Header>
    <div class="flex-box plr120">
      <div class="flex-grow-1 fs28 col10 fwb lh86">您绑定的设备</div>
      <div @click="toBind" class="flex-box">
        <img class="add_device cursor" src="../assets/static/icon/add_device.png" alt="" />
        <div class="colb fs20 lh30 cursor">绑定设备</div>
      </div>
    </div>
    <div class="main">
      <div v-for="(item, index) in list" :key="index" class="ptb30 part1 flex cursor">
        <img class="img" :src="oss + item.thumb_image + w500" alt="" />
        <div class="flex-grow-1">
          <div class="fs24 col10 fwb lh44 m-ellipsis mb10">
            {{ item.name }}
          </div>
          <div class="fs24 col10 fwb lh44 mb43">{{ item.sub_name }}</div>
          <div class="flex-box">
            <div class="flex-grow-1 fs20 col85 lh28">序列号：{{ item.goods_no }}</div>
            <div @click="toOrder(index)" class="btn fs16 colb tc cursor">选择此设备</div>
          </div>
        </div>
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>
<script>
import { useHead } from "@unhead/vue";
import axios from "@/axios";
import router from "@/router";
import { getCurrentInstance } from "vue";
import { ElMessage, ElMessageBox } from "element-plus";

export default {
  name: "productDetail",
  setup() {
    useHead({
      title: "我的设备",
      meta: [
        { name: "description", content: "This is my page description" },
        { property: "og:title", content: "My Page Title" },
        { property: "og:description", content: "This is my page description" },
        { property: "og:url", content: "https://example.com/my-page" },
        { property: "og:image", content: "https://example.com/my-image.jpg" },
      ],
      link: [{ rel: "canonical", href: "https://example.com/my-page" }],
    });
  },
  data() {
    return {
      oss: getCurrentInstance().appContext.config.globalProperties.$oss,
      w1000: getCurrentInstance().appContext.config.globalProperties.$w1000,
      w500: getCurrentInstance().appContext.config.globalProperties.$w500,
      list: [],
      type: '',
      ids: '',
      goods_num: ''
    };
  },
  created() {
    this.type = this.$route.params.type
    this.ids = this.$route.params.ids
    this.goods_num = this.$route.params.goods_num
    this.getList()
  },
  methods: {
    toBind() {
      router.push({
        name: 'bindDevice'
      })
    },
    getList() {
      axios.post('ag/device_list', {
        is_no_acare: 1,
        acare_id: this.ids
      })
        .then(res => {
          this.list = res.data
          if (!res.data[0]) {
            ElMessageBox.alert('您无此型号美容仪需购买“A CARE” ', '提示', {
              confirmButtonText: '确定',
              callback: res => {
                window.history.back();
              }
            });
          }
        })
        .catch(error => {
          console.error(error);
        });
    },
    toOrder(index) {
      router.push({
        name: 'confirmOrder', params: {
          ids: this.ids,
          device_id: 0,
          goods_sku_id: 0,
          goods_num: this.goods_num,
          acare_goods_id: 0,
          coupon_id: 0,
          acare_device_id: this.list[index].id,
          type: this.type
        }
      });
    }
  },
};
</script>
<style lang="less" scoped>
.container {
  background: #fff;
  width: 100vw;
  overflow-x: hidden;
  padding-top: 103px;
}

.main {
  width: 770px;
  margin: 0px auto 103px;
}

.add_device {
  width: 16px;
  height: 16px;
  display: block;
  object-fit: cover;
}

.part1 {
  border-bottom: 1px solid #e3e3e3;

  .img {
    width: 173px;
    height: 173px;
    display: block;
    object-fit: cover;
    margin-right: 53px;
  }
}

.btn {
  padding: 0 17px;
  text-align: center;
  height: 34px;
  line-height: 34px;
  background: #f0f0f7;
  border-radius: 23px;
}
</style>